import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>(theme => ({
  button: {
    backgroundColor: theme.palette.common.white,
    padding: `${theme.spacing(1.75)}px ${theme.spacing(1.5)}px`,
  },
  buttonDisabled: {
    backgroundColor: theme.palette.common.gray200,
  },
  container: {
    display: 'inline-flex',
    flexDirection: 'column',
  },
  next: {
    borderBottomLeftRadius: theme.misc.borderRadius,
    borderBottomRightRadius: theme.misc.borderRadius,
  },
  previous: {
    borderBottom: theme.customBorders.gray200,
    borderTopLeftRadius: theme.misc.borderRadius,
    borderTopRightRadius: theme.misc.borderRadius,
  },
}));

export default useStyles;
